export enum ElementEnum {
  DataSelector = 1,
  AccountDistribution = 2,
  HistoricalNav = 3,
}
